import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Subject } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class NotesService {
  public $fetchNotes: Subject<string> = new Subject();
  apiUrl: string;
  headers = new HttpHeaders().set('Content-Type', 'application/json');
  constructor(private httpClient: HttpClient) {
    this.apiUrl = 'assets/api-data/note-detail.json';
  }


  getNotesList() {
    return this.httpClient.get(this.apiUrl)
      .pipe(map((response: Response) => { return response; }));
  }
  handleError(handleError: any) {
    throw new Error("Method not implemented.");
  }
}
